import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';

const theme = createMuiTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ['Open Sans'].join(','),
    },

    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#055C32',
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
      secondary: {
        // light: will be calculated from palette.primary.main,
        main: '#3783e7',
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
      error: {
        // light: will be calculated from palette.primary.main,
        main: '#f018a6',
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */
    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        disableRipple: false, // No more ripple, on the whole application 💣!
      },

      // Set default elevation to 1 for popovers.
      MuiPopover: {
        elevation: 1,
      },
    },

    overrides: {
      MUIDataTableSearch: {
        main: {
          position: 'relative',
          marginLeft: '2.25rem',
          '@media (max-width: 575.98px)': {
            width: '100%',
            marginLeft: '12px',
          },
        },
        searchIcon: {
          display: 'none',
        },
        searchText: {
          '& .MuiInputBase-root': {
            width: '100% !important',
            maxWidth: '500px',
            background: '#f3f4f6',
            borderRadius: '4px',
            '&::before, &::after, &:hover:not(.Mui-disabled)::before': {
              borderBottom: '0 !important',
            },
          },
          '& input[aria-label="Search"]': {
            height: '24px',
            padding: '8px 12px 8px 30px',
            fontSize: '1.1rem',
            textAlignLast: 'left',
          },
          '@media (max-width: 575.98px)': {
            '& .MuiInputBase-root': {
              width: '90% !important',
              maxWidth: '90%',
            },
          },
        },
        clearIcon: {
          position: 'absolute',
          top: '50%',
          left: '-6px',
          zIndex: 2,
          margin: 0,
          transform: 'translateY(-50%)',
          pointerEvents: 'auto',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
  },
);

export function MaterialThemeProvider(props) {
  const { children } = props;

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
